import { useQueryClient } from 'react-query';

import { CONTROL_SETTINGS_TASKS } from 'modules/onboarding/setup-hub/constants/taskSections';
import {
  type HubTask,
  type HubTaskType,
} from 'modules/onboarding/types/hubTask';

export const useUpdateCachedTaskStatus = () => {
  const queryClient = useQueryClient();

  return (
    updatedTaskType: HubTaskType,
    context: 'onboarding' | 'setup_hub',
  ) => {
    queryClient.setQueryData<HubTask[]>(
      ['onboarding-hub', 'tasks', context],
      (tasks) => {
        if (!tasks) {
          return [];
        }
        const result: HubTask[] = tasks.map((task) => {
          if (task.type === updatedTaskType) {
            return {
              ...task,
              status: 'completed',
            };
          }
          return task;
        });

        // when wallet_funding is completed, we enable company_setup
        if (updatedTaskType === 'wallet_funding') {
          const companySetupTaskIndex = result.findIndex(
            (task) => task.type === 'company_setup',
          );
          if (
            companySetupTaskIndex > -1 &&
            result[companySetupTaskIndex].status !== 'completed'
          ) {
            result[companySetupTaskIndex].status = 'ongoing';
          }
        }
        // when company_setup is completed, we enable member_invite
        else if (updatedTaskType === 'company_setup') {
          const memberInviteTaskIndex = result.findIndex(
            (task) => task.type === 'member_invite',
          );
          if (memberInviteTaskIndex > -1) {
            result[memberInviteTaskIndex].status = 'ongoing';
          }
        }
        // when all control settings tasks are completed, we enable accounting software task
        else if (CONTROL_SETTINGS_TASKS.includes(updatedTaskType)) {
          const controlSettingsTasks = result.filter(
            (task) => task.category === 'control_settings',
          );
          const accountingSoftwareTaskIndex = result.findIndex(
            (task) => task.type === 'accounting_software',
          );
          if (
            controlSettingsTasks.every((task) => task.status === 'completed') &&
            accountingSoftwareTaskIndex > -1 &&
            result[accountingSoftwareTaskIndex].status === 'disabled'
          ) {
            result[accountingSoftwareTaskIndex].status = 'ongoing';
          }
        }
        // when accounting_software task is completed, we enable all accounting tasks
        else if (updatedTaskType === 'accounting_software') {
          result.forEach((task, index) => {
            if (task.category === 'accounting' && task.status === 'disabled') {
              result[index].status = 'ongoing';
            }
          });
        }
        return result;
      },
    );
  };
};
